import { useApp } from "../context/AppContext";
import { useState } from "react";
import AIReportModal from "./AIReportModal";

const GRADIENT     = "linear-gradient(135deg, #29ABE2 0%, #5E5EDE 50%, #9B35C8 100%)";
const ACTIVE_COLOR = "#7B6FE8";

// SECURITY: shared mouse event handlers use e.currentTarget (not e.target)
// e.target can refer to a child element if the event bubbles up, causing the
// style to be applied to the wrong element. e.currentTarget always refers to
// the element the listener is attached to.
const onEnter = e => { e.currentTarget.style.color = ACTIVE_COLOR; };
const onLeave = e => { e.currentTarget.style.color = "var(--text-secondary)"; };

// Shared style for all footer nav buttons
// FIX: use text-secondary instead of text-tertiary for readable contrast in both dark and light mode
const linkStyle = {
  background:     "none",
  border:         "none",
  cursor:         "pointer",
  fontSize:       12,
  color:          "var(--text-secondary)",
  fontFamily:     "'DM Sans', sans-serif",
  padding:        0,
  textDecoration: "none",
  transition:     "color 0.2s",
};

export default function Footer() {
  const { navigate } = useApp();
  const [showReport, setShowReport] = useState(false);

  return (
    <div style={{
      borderTop:      "1px solid var(--border)",
      marginTop:      48,
      padding:        "20px 0 8px",
      display:        "flex",
      alignItems:     "center",
      justifyContent: "space-between",
      flexWrap:       "wrap",
      gap:            12,
    }}>

      {/* Left — branding */}
      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
        <div style={{
          width:          22,
          height:         22,
          background:     GRADIENT,
          borderRadius:   6,
          display:        "flex",
          alignItems:     "center",
          justifyContent: "center",
        }}>
          <span style={{ color:"#fff", fontWeight:800, fontSize:11 }}>V</span>
        </div>
        <span style={{ fontSize:12, color:"var(--text-secondary)", fontFamily:"'DM Sans', sans-serif" }}>
          © {new Date().getFullYear()} Vorsia. All rights reserved.
        </span>
      </div>

      {/* Right — legal + nav links */}
      <div style={{ display:"flex", gap:24, alignItems:"center" }}>

        <button
          onClick={() => navigate("privacy")}
          style={linkStyle}
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
        >
          Privacy Policy
        </button>

        <span style={{ color:"var(--border)", fontSize:12 }}>·</span>

        <button
          onClick={() => navigate("terms")}
          style={linkStyle}
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
        >
          Terms of Service
        </button>

        <span style={{ color:"var(--border)", fontSize:12 }}>·</span>

        {/* FIX: was <a href="/?page=employers"> causing full page reload and React state loss
            Now uses navigate() consistent with all other footer links */}
        <button
          onClick={() => navigate("employers")}
          style={linkStyle}
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
        >
          For Employers
        </button>

        <span style={{ color:"var(--border)", fontSize:12 }}>·</span>

        <button
          onClick={() => navigate("about")}
          style={linkStyle}
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
        >
          About
        </button>

        <span style={{ color:"var(--border)", fontSize:12 }}>·</span>

        {/* Report AI Content — required by Microsoft Store policy 11.16 */}
        <button
          onClick={() => setShowReport(true)}
          style={linkStyle}
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
        >
          ⚑ Report AI
        </button>

      </div>
      {showReport && <AIReportModal onClose={() => setShowReport(false)} context="Vorsia AI" />}
    </div>
  );
}
